export function ackBanner() {
  localStorage.setItem('ackBannerDate', new Date().toISOString());
}

export function shouldShowBanner() {
  const ackBannerDate = localStorage.getItem('ackBannerDate');
  if (!ackBannerDate) {
    return true;
  }
  const date = new Date(ackBannerDate);
  const today = new Date();
  return date.getDate() !== today.getDate();
}
